import { Dipendente } from './dipendente';

export class DipendenteChangeModel {
  dipendente: Dipendente;
  idArticoliDett: number[];
  rimuoviDettPrecedente: boolean;
}